import { useStoreSettings } from './useStoreSettings';

/**
 * Mağaza adı — TEK kaynak.
 *
 * İşletme adı koda gömülmez; ayarlardan gelir. Buradaki yedek değer
 * yalnızca ayarlar henüz yüklenmediği ilk anda kullanılır ve sayfa
 * başlığının boş kalmasını önler.
 *
 * Mağaza adını değiştiren bir işletme, kod değişikliği olmadan tüm
 * sekme başlıklarında yeni adını görür.
 */
const FALLBACK = 'Hayal Çiçek & Hediyelik';

export function useStoreName(): string {
  const { data } = useStoreSettings();
  const name = data?.['store.name'];

  return typeof name === 'string' && name.trim() !== '' ? name.trim() : FALLBACK;
}

/** "Sepetim" + mağaza adı → "Sepetim — Hayal Çiçek & Hediyelik" */
export function buildPageTitle(pageName: string, storeName: string): string {
  return `${pageName} — ${storeName}`;
}
